/** biome-ignore-all lint/a11y/noNoninteractiveTabindex: avoid-breaking */

'use client';

import React, { type FC, useEffect, useState } from 'react';

import cn from 'classnames';

import type { SwitchProps } from './Switch.types';

import styles from './Styles/Default.module.css';

export const Switch: FC<SwitchProps> = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ checked, onChange, disabled = false, className }, ref) => {
    const classNames = cn(styles.container, className);
    const [isChecked, setChecked] = useState(checked);

    useEffect(() => {
      setChecked(checked);
    }, [checked]);

    const handleSwitch = (
      e: React.ChangeEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>,
    ) => {
      setChecked(!isChecked);
      onChange(e);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e?.key === 'Enter') {
        handleSwitch(e);
      }
    };

    return (
      <div className={classNames}>
        <input
          checked={isChecked}
          disabled={disabled}
          onChange={e => handleSwitch(e)}
          ref={ref}
          type="checkbox"
        />
        <span className={styles.switch} tabIndex={0} onKeyDown={handleKeyDown} />
      </div>
    );
  },
);

Switch.displayName = 'Switch';
